import { render, staticRenderFns } from "./IdNumberCheckStep.vue?vue&type=template&id=3a98d26e&scoped=true"
import script from "./IdNumberCheckStep.vue?vue&type=script&lang=js"
export * from "./IdNumberCheckStep.vue?vue&type=script&lang=js"
import style0 from "./IdNumberCheckStep.vue?vue&type=style&index=0&id=3a98d26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98d26e",
  null
  
)

export default component.exports